var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":_vm.getPath(_vm.link),"stroke":_vm.linkStroke,"fill":"none","stroke-width":_vm.linkStrokeWidth}})])
}
var staticRenderFns = []

export { render, staticRenderFns }